import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Absensi & Nilai',
    description: 'Portal akademik untuk mencatat absensi, nilai, dan jurnal mengajar siswa dalam satu tempat.',
    url: getOrigin()
}
